import { Component, HostBinding, signal, ChangeDetectionStrategy} from '@angular/core';
import { WebsocketService } from "./../services/websocket.service";
import { EventRunner } from './../core/app.core.events';
import { CborDataDecorator } from "./../core/app.core.cbor";
import { NeverumeComponent } from "./../neverume.component";     
import { Directionality } from '@angular/cdk/bidi';
import { AuthenticationComponent } from './authentication.component';
import { ArrayAssociative } from "./../core/array.core.data";

const cbor = require('cbor-web');
let cdd = new CborDataDecorator();
 
@Component({
  selector: 'registration',
  
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  providers: [NeverumeComponent, EventRunner, AuthenticationComponent],
  standalone: !true,
  changeDetection: ChangeDetectionStrategy.OnPush
  
})

export class RegistrationComponent {
	@HostBinding('class') classes = 'horizontal-scroll-containers';
	first: string = '';
	last: string = '';
	middle: string = '';
	selfsuperscription: string = '';
	password: string = '';
	cpassword: string = '';
	phone = '';
	post = '';
	currentDirection: any;
	hide = signal(true);
	

	constructor(private directionality: Directionality, private websoketService: WebsocketService) {
		this.currentDirection = this.directionality.value;
;
	}
	
	lookEvent(event: Event) {
	  this.hide.set(!this.hide());
	  event.stopPropagation();
	}
	
	onSubmit() {
		
		let message: ArrayAssociative = {
				event: 'registation',
				route: '/signverify/registration',
				first: this.first,
				last: this.selfsuperscription,
				middle: this.middle,
				selfsuperscription: this.selfsuperscription,
				password: this.password,
				cpassword: this.cpassword,
				phone: this.phone,
				post: this.post,
			}
			
		this.websoketService.sendws(message);
	}

}
